export function dividirEnDecimales(numero: number): string {
  return numero.toLocaleString("es-ES");
}
